export const FORM_KEYS = {
  PET_DETAILS_RADIOS: 'petDetailsRadios',
  CLAIM_SUMMARY: 'claimSummary',
  INVOICES: 'invoices',
  VET_NOTES: 'vetNotes',
  VERIFY_EMAIL_CODE: 'verifyEmailCode',
  VERIFY_PHONE_CODE: 'verifyPhoneCode',
  ACCOUNT_NAME: 'accountName',
  BSB: 'bsb',
  ACCOUNT_NUMBER: 'accountNumber',
  CURRENT_PASSWORD: 'currentPassword',
  NEW_PASSWORD: 'newPassword',
  CONFIRM_PASSWORD: 'confirmPassword',
  NEW_MOBILE_NUMBER: 'newMobileNumber',
  NEW_EMAIL: 'newEmail',
  APPLY_TO_ALL_PETS: 'applyToAll',
  CHAT_TYPE: 'chatType',
  PET_SPECIES: 'petSpecies',
  PET_NAME: 'petName',
  PET_BREED: 'petBreed',
  PET_AGE: 'petAge',
  PET_GENDER: 'petGender',
  CONCERN_SUMMARY: 'concernSummary',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL_ADDRESS: 'emailAddress',
  MOBILE_NUMBER: 'mobileNumber',
  FULL_POLICY_NUMBER: 'fullPolicyNumber',
  VET_CONSULTATION_NOTES: 'vetConsultationNotes',
  POLICY_HOLDER_ADDRESS_AUTOCOMPLETE_SEARCH: 'policyHolderAddressAutocomplete',
  TERMS_OF_USE: 'termsOfUse'
};

export const UPLOAD_DOCUMENTS_FORM_KEYS = {
  CLIENT_CORRESPONDENCE: 'CCORRES',
  CLAIM_FORM: 'CFORM',
  VET_CONSULTATION_NOTES: 'CNNOTES',
  PATHOLOGY_REPORT: 'PATH',
  PURCHASE_RECEIPT: 'PPURCHASE',
  PRE_AUTHORIZATION: 'PREAUTH',
  RECEIPT: 'RECEIPT',
  RADIOLOGY_REPORT: 'RTG',
  VET_HISTORY: 'VETHIST',
  INVOICE: 'INVOICE',
  OTHER: 'OTHER',
  CLIENT_CORRESPONDENCE_CHECKLIST: 'CCORRES_CHECKLIST',
  CLAIM_FORM_CHECKLIST: 'CFORM_CHECKLIST',
  VET_CONSULTATION_NOTES_CHECKLIST: 'CNNOTES_CHECKLIST',
  PATHOLOGY_REPORT_CHECKLIST: 'PATH_CHECKLIST',
  PURCHASE_RECEIPT_CHECKLIST: 'PPURCHASE_CHECKLIST',
  PRE_AUTHORIZATION_CHECKLIST: 'PREAUTH_CHECKLIST',
  RECEIPT_CHECKLIST: 'RECEIPT_CHECKLIST',
  RADIOLOGY_REPORT_CHECKLIST: 'RTG_CHECKLIST',
  VET_HISTORY_CHECKLIST: 'VETHIST_CHECKLIST',
  INVOICE_CHECKLIST: 'INVOICE_CHECKLIST',
  OTHER_CHECKLIST: 'OTHER_CHECKLIST',
  COMMENTS: 'COMMENTS'
};
